module.exports = __webpack_public_path__ + "static/media/welcome_cats.8c0c3b2c.png";